import React, { useState } from "react";
import { FaCopy } from "react-icons/fa";
import { toast } from "react-toastify"; // Import toast from react-toastify
import "react-toastify/dist/ReactToastify.css"; // Import the CSS for toast notifications

const CopyToClipboard = ({ text }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyClick = () => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);

    textarea.select();
    textarea.setSelectionRange(0, 99999);

    document.execCommand("copy");

    document.body.removeChild(textarea);

    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 1500);

    // Display a toast notification
    toast.success("Copied!", {
      position: toast.POSITION.TOP_CENTER, // Adjust the position as needed
    });
  };

  return (
    <div className="copy-container">
      <div
        className={`success-badge ${copied ? "copied" : ""}`}
        onClick={handleCopyClick}
      >
        {text}
        {!copied && (
          <span
            className="copy-icon"
            onClick={handleCopyClick}
            style={{ marginLeft: "8px" }} 
          >
            <FaCopy style={{ display: "inline-block" }} />
          </span>
        )}
      </div>
    </div>
  );
};

export default CopyToClipboard;
